module.exports = __webpack_public_path__ + "img/ch-wash.58b47823.jpg";